export const Endpoints = {
  GET: {
    //ACCOUNT

    // White-label by DNS Host / X-Forwarded-Host (optional X-Dev-Instance-Host in IsDevelopment).
    theme: `/v1/public/branding`,
    // Authenticated refresh (same shape); optional post-login.
    themeMobile: `/v1/mobile/branding`,

    // Carteira IB → MobileService /v1/ib/accounts/* → BaaS /v1/accounts/{activeId}/*
    // (transparent account proxy). Mobile app keeps /v1/account/*.
    accountSettings: `/v1/ib/accounts/me`,
    // Google Authenticator TOTP secret (AccountPerson.SecretTwoAuth)
    accountAuthenticator: `/v1/ib/accounts/me/authenticator`,
    // Primary BRL cards: same BaaS BalanceList as multi-currency (client picks BRL).
    accountBalance: `/v1/ib/accounts/balances`,
    // Multi-currency: GET balances (foreign-only filtered client-side; web = all incl. BRL).
    accountBalances: `/v1/ib/accounts/balances`,
    accountBalancesWeb: `/v1/ib/accounts/balances`,
    // Multi-currency banking rails (deposit/dados) → BaaS GET /v1/accounts/{id}/currencies
    accountCurrencies: `/v1/ib/accounts/currencies`,
    accountStatement: `/v1/ib/accounts/statements`,
    // AccountBalanceCategory catalog for Extrato Categoria filter.
    accountStatementCategories: `/v1/ib/accounts/statement-categories`,
    // Person account list for IB home selector (native MobileService; balances from BaaS).
    ibAccounts: `/v1/ib/accounts`,
    // Still api-carteira-shaped under MobileService /v1/ib/* (export/KYC may proxy).
    individualAccountStatus: `/v1/ib/accounts/individual`,
    individualAccountLiveness: `/v1/ib/accounts/individual/liveness`,

    excelStatement: `/v1/ib/accounts/statements/excel`,
    csvStatement: `/v1/ib/accounts/statements/csv`,
    ofxStatement: `/v1/ib/accounts/statements/ofx`,
    //PAYMENTS
    consultBarcode: `/payments/barcode/`,

    //ACCOUNT BC LIST — peer P2P lookup by CPF/CNPJ (IB native)
    valutAccounts: `/v1/ib/transfers/accounts`,

    //BANK LIST
    banksList: `/banks`,

    //CARDS
    cardSettings: `/cards`,
    cardStatement: `/cards/statements`,

    //CONTACTS
    contactStatement: ``,

    //RECEIPTS — list pages use account statements (useTransactionsData); legacy path unused.
    receiptStatement: `/receipts`,

    //TRANSFERS — list still proxies api-carteira via IB BFF
    transferStatement: `/v1/ib/transfers`,

    //TICKETS
    ticketStatement: `/boleto`,

    //PIX — Carteira IB → MobileService /v1/ib/pix/* → BaaS /v1/pix/accounts/{id}/*
    pixList: `/v1/ib/pix/transactions`,
    pixCards: `/v1/ib/pix/cards`,
    pixKeys: `/v1/ib/v2/pix/keys`,
    pixKeyDetail: `/v1/ib/v2/pix/keys`,
    pixPayments: `/v1/ib/pix/payments`,
    pixReceive: `/v1/ib/pix/receive`,

    //SUBACCOUNTS
    subAccountsList: `/subaccount`,
    subaccount: `/subaccount`,

    subAccountDetails: `/subaccount`,
    subAccountQRCode: `/subaccount`,
    //Operators
    operatorsList: "/operators",

    //Invoices
    invoices: `/v2/anticipation/invoices`,
    invoiceBuyers: `/v2/anticipation/customers`,
    invoiceDashboard: `/v2/anticipation/dashboard`,
    invoiceDuplicates: `/v2/anticipation/nfs-dup`,
    invoiceStatus: `/v2/anticipation/hasLimit`,

    // SUPPORT
    support: `/support`,

    // FIAT MARKETS
    fiatMarketQuotes: `/v1/fiat/markets/quotes`,

    // NOTIFICATIONS — person inbox (MobileService native)
    ibNotifications: `/v1/ib/notifications`,
    ibNotificationsUnreadCount: `/v1/ib/notifications/unread-count`,
  },
  PUT: {
    new_password: ``,
    reset_password: ``,
    logout: ``,
    confirmPix: `/v1/ib/pix`,
    operatorsActiveInactive: "/operators",
    operators: "/operators",
  },
  POST: {
    //AUTH — mobile-service BaaS JWT (IB v2). Not api-carteira /auth.
    login: `/v1/auth/login`,
    // TODO: REMOVE after HML — DEV_SEED set-password for VALUT GLOBAL CNPJ (Development only).
    devSetPassword: `/v1/auth/dev/set-password`,
    //RESET (still scaffolded under /v1/ib/auth on mobile — not wired for v2 yet)
    reset: `/auth/reset`,

    smsToken: `/v1/auth/token`,
    verifyDevice: `/v1/auth/verify`,

    //GET TOKEN AUTH
    getToken: "/v1/utils/send-token",

    // Activate selected IB account (MobileService /v1/ib/accounts/active_account/{id})
    activateAccount: `/v1/ib/accounts/active_account`,

    // Register transactional password (person TransactionalPassword*)
    transactionalPassword: `/v1/ib/accounts/transactional_password`,

    // Conta internacional → BaaS account proxy
    accountFxQuote: `/v1/ib/accounts/fx/quotes`,
    accountFxConversion: `/v1/ib/accounts/fx/conversions`,
    accountOutboundTransfer: `/v1/ib/accounts/transfers`,

    //TRANSFERS — peer P2P create (IB native internal)
    transactionPay: `/v1/ib/transfers`,

    //RECEIPTS
    ticketStatement: `/boleto`,

    //PAYMENTS
    barcodePayment: `/payments/barcode`,

    //PIX — MobileService /v1/ib/* BFF → BaaS Pix
    createPixQRCode: `/v1/ib/pix/charge`,
    pixChargesList: `/v1/ib/pix/charges`,
    pixPayment: `/v1/ib/pix`,
    pixKeyCreate: `/v1/ib/v2/pix/keys`,
    pixKeyLink: `/v1/ib/v2/pix/keys`,
    individualAccountCreate: `/accounts/individual`,
    businessAccountCreate: `/baas/business-accounts`,
    personalAccountCreate: `/baas/personal-accounts`,
    individualAccountKyc: `/accounts/individual/kyc`,
    individualAccountLiveness: `/accounts/individual/liveness`,

    //BATCH TRANSFERS
    receiveValidateBatchTransfers: "/transfers/batch/send-file",
    sendBatchTransfers: "/transfers/batch",

    //Operatros
    operatorsCreate: "/operators",

    //SubAccounts
    subAccountCreate: `/subaccount`,
    subaccount: `/subaccount`,
    subAccountQRCodeCreate: `/subaccount`,
    subAccountBalanceAdd: `/subaccount/p2p/add`,
    subAccountBalanceWithdraw: `/subaccount/p2p/withdraw`,

    invoices: `/v2/anticipation/invoice`,
    invoicesValidation: `/v2/anticipation/validate-invoices`,
    invoiceDuplicates: `/v2/anticipation/request-nf`,

    // SUPPORT
    support: `/support`,

    // NOTIFICATIONS
    ibNotificationRead: `/v1/ib/notifications`,
    ibNotificationsReadAll: `/v1/ib/notifications/read-all`,
  },
  PATCH: { restoreSession: `/v1/auth/refresh` },
  DELETE: {
    //TICKETS
    ticketStatement: `/boleto`,

    returnPix: `/v1/ib/pix`,
    pixKeyDelete: `/v1/ib/v2/pix/keys`,
    pixKeyUnlink: `/v1/ib/v2/pix/keys`,

    invoices: `/v2/anticipation/invoice`,
  },
};
